export default "<div [chart]=\"humidity\"></div>\n<button type=\"button\" (click)=\"refrash()\" class=\"btn btn-primary\">Refreash</button>"